import React from 'react';
import { Button } from '../UI/Button';

export interface PowerBreakButtonProps {
  onStart: () => void;
  isActive: boolean;
  onCancel: () => void;
}

/**
 * PowerBreakButton component for initiating and canceling power breaks
 * 
 * Requirements:
 * - Show "Power Break" button when inactive
 * - Show "Cancel Power Break" button when active
 * - Call onStart/onCancel callbacks on click
 * - Apply buttonPrimary class for fire accent styling
 * - Use Button base component with primary variant
 * - Ensure 44x44px minimum touch target on mobile
 * 
 * Validates: Requirements 4.1, 4.7
 */
export const PowerBreakButton: React.FC<PowerBreakButtonProps> = ({
  onStart,
  isActive,
  onCancel,
}) => {
  const handleClick = () => {
    if (isActive) {
      onCancel();
    } else {
      onStart();
    }
  };

  return (
    <Button
      variant="primary"
      onClick={handleClick}
      style={{
        minWidth: '44px',
        minHeight: '44px',
      }}
      aria-label={isActive ? 'Cancel Power Break' : 'Start Power Break'}
    >
      {isActive ? 'Cancel Power Break' : 'Power Break'}
    </Button>
  );
};
